/**
 * PlatformLogo — petit badge indiquant la plateforme d'origine d'une réservation
 * (Airbnb / Lodgify) affiché dans le strip du calendrier, près du nom.
 *
 * La source « OH », « manual », « direct », « csv »… provient de Lodgify (réservation directe).
 * Source vide/inconnue → « à renseigner ».
 * Couleurs de marque : Airbnb Rausch #FF385C · Lodgify jaune #FFF75B sur noir #050404.
 */
export function platformOf(source) {
  const s = (source || "").toLowerCase().trim();
  if (!s) return "unknown";
  if (s.includes("airbnb")) return "airbnb";
  return "lodgify";
}

const BASE = {
  display: "inline-flex",
  alignItems: "center",
  flex: "0 0 auto",
  borderRadius: 3,
  padding: "0 4px",
  height: 13,
  fontSize: 9,
  fontWeight: 800,
  letterSpacing: 0,
  textTransform: "none",
  lineHeight: "13px",
};

export default function PlatformLogo({ source }) {
  const p = platformOf(source);
  if (p === "airbnb") {
    return (
      <span data-testid="rg-platform-airbnb" title="Réservation Airbnb"
        style={{ ...BASE, background: "#fff", color: "#FF385C" }}>
        Airbnb
      </span>
    );
  }
  if (p === "lodgify") {
    return (
      <span data-testid="rg-platform-lodgify" title="Réservation Lodgify (directe)"
        style={{ ...BASE, background: "#050404", color: "#FFF75B" }}>
        Lodgify
      </span>
    );
  }
  return (
    <span data-testid="rg-platform-unknown" title="Plateforme d'origine à renseigner"
      style={{ ...BASE, background: "transparent", border: "1px solid rgba(255,255,255,0.65)", color: "#fff", fontWeight: 600, fontStyle: "italic" }}>
      à renseigner
    </span>
  );
}
